// Un arqueo que quedó abierto de un día anterior (el backend lo marca
// `vencido`) o que ya se contó para el cierre (`en_cierre`) sólo se puede
// cerrar: cualquier otra ruta del POS va al cierre.
// Con el vencido las rutas `sinCaja` (stock, inventario) siguen abiertas; con
// el conteo hecho no se sale del cierre para nada.
function redirigirSiArqueoVencido(store, to) {
  const { arqueoCaja } = store.state.sucursales;
  if (!arqueoCaja || !(arqueoCaja.vencido || arqueoCaja.en_cierre)) return null;
  if (to.name === 'pos.cerrarCaja') return null;
  if (!arqueoCaja.en_cierre && to.matched.some(r => r.meta.sinCaja)) return null;
  console.warn("%c ⏰ Arqueo vencido o en cierre. Redirigiendo al cierre...", "color: #e67e22;");
  return { name: 'pos.cerrarCaja' };
}

export async function checkInitData({ store, to }) {
  const { isLogged } = store.state.auth;
  const { loadData: hasLoadData } = store.state.initialData;
  const context = to.matched.find(r => r.meta.context)?.meta.context || null;

  const sinCaja = to.matched.some(r => r.meta.sinCaja);

  // Solo ejecutamos esta lógica si está logueado y va hacia el POS
  if (isLogged && context === 'pos') {
    
    console.log("%c 🧱 Legor Guard: Verificando integridad del POS...", "color: #BA6B30; font-weight: bold; background: rgba(186,107,48,0.1); padding: 2px 5px; border-radius: 4px;");

    if (!hasLoadData) {
      console.log("%c 📥 Datos no cargados. Iniciando fetchInitConfig...", "color: #F5A623;");
      
      try {
        // Ejecutamos la acción del store
        const initState = await store.dispatch('initialData/fetchInitConfig', {}, { root: true });
        
        console.table({
          "Sucursal": initState.hasSucursal ? "✅ OK" : "❌ Faltante",
          "Caja": initState.hasCaja ? "✅ OK" : "❌ Faltante",
          "Arqueo": initState.hasArqueo ? "✅ OK" : "❌ Faltante"
        });

        if (!initState.hasSucursal) return { name: 'pos.seleccionarSucursal' };
        // Sin caja o sin arqueo el dashboard muestra "iniciá una caja"; las rutas
        // del flujo de apertura tienen que poder recargarse sin ser rebotadas.
        if (!initState.hasCaja) {
          if (sinCaja || to.name === 'pos.cajas' || to.name === 'pos.seleccionarSucursal') return null;
          return { name: to.name === 'pos.iniciarCaja' ? 'pos.cajas' : 'pos.dashboard' };
        }
        if (!initState.hasArqueo) {
          if (sinCaja || to.name === 'pos.cajas' || to.name === 'pos.iniciarCaja') return null;
          return { name: 'pos.dashboard' };
        }

        const vencido = redirigirSiArqueoVencido(store, to);
        if (vencido) return vencido;

        // Tiene todo configurado: si intentaba acceder a una ruta de configuración, redirigir
        const configRoutes = ['pos.seleccionarSucursal', 'pos.cajas', 'pos.iniciarCaja'];
        if (configRoutes.includes(to.name)) return { name: 'pos.venta.registrar' };

      } catch (e) {
        console.error("%c 🔥 Error crítico en checkInitData:", "color: white; background: red; padding: 2px 5px;", e);
        return { name: 'error', params: { errorMessage: 'Error al cargar configuración inicial' } };
      }
    } else {
      // Los datos ya existen en el Store, verificamos consistencia
      const { sucursal, caja, arqueoCaja } = store.state.sucursales;
      // Permitir rutas de configuración solo cuando realmente falta el dato correspondiente
      if (to.name === 'pos.seleccionarSucursal' && !sucursal) return null;
      if (to.name === 'pos.cajas' && !caja) return null;
      if (to.name === 'pos.iniciarCaja' && !arqueoCaja) return null;

      // Si intenta ir a una ruta de configuración pero ya tiene todo configurado, redirigir
      const allowedConfigRoutes = ['pos.seleccionarSucursal', 'pos.cajas', 'pos.iniciarCaja'];
      if (allowedConfigRoutes.includes(to.name)) {
        console.log(`%c ⏭️ Sesión completa, redirigiendo desde ruta de configuración (${to.name})`, "color: #7f8c8d;");
        if (!sucursal) return { name: 'pos.seleccionarSucursal' };
        if (!caja) return { name: 'pos.cajas' };
        if (!arqueoCaja) return { name: 'pos.iniciarCaja' };
        return { name: 'pos.venta.registrar' };
      }

      console.log("%c ⚙️ Validando consistencia de sesión activa...", "color: #3498db;");

      const vencido = redirigirSiArqueoVencido(store, to);
      if (vencido) return vencido;

      if (!sucursal) {
        console.warn("%c ⚠️ Sucursal faltante. Redirigiendo...", "color: #e67e22;");
        return { name: 'pos.seleccionarSucursal' };
      }
      if (!caja) {
        console.warn("%c ⚠️ Caja no seleccionada. Redirigiendo...", "color: #e67e22;");
        return sinCaja ? null : { name: 'pos.dashboard' };
      }
      if (!arqueoCaja) {
        console.warn("%c ⚠️ Arqueo no encontrado. Redirigiendo...", "color: #e67e22;");
        return sinCaja ? null : { name: 'pos.dashboard' };
      }
      
      console.log("%c ✅ Integridad del POS verificada correctamente.", "color: #27ae60; font-weight: bold;");
    }
  }
  
  return null; 
}